"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var favoriteNodeParser = require("./helpers/favoriteNodeParser");
var updateFavoritesUserOptionService_1 = require("../services/updateFavoritesUserOptionService");
var owa_mail_favorites_store_1 = require("owa-mail-favorites-store");
var getUserConfiguration_1 = require("owa-session-store/lib/actions/getUserConfiguration");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.action('updateFavoritesUserOption')(legacy_1.select({
    favoritesFolderNodes: function () { return owa_mail_favorites_store_1.favoritesStore.favoritesFolderNodes; },
    favoritesPersonaNodes: function () { return owa_mail_favorites_store_1.favoritesStore.favoritesPersonaNodes; },
    favoriteSearches: function () { return owa_mail_favorites_store_1.favoritesStore.favoriteSearches; },
    favoriteCategories: function () { return owa_mail_favorites_store_1.favoritesStore.favoriteCategories; },
    orderedFavoritesNodeIds: function () { return owa_mail_favorites_store_1.favoritesStore.orderedFavoritesNodeIds; },
})(function updateFavoritesUserOption(state) {
    var favoriteNodesRaw = favoriteNodeParser.serialize(state.orderedFavoritesNodeIds, state.favoritesFolderNodes, state.favoritesPersonaNodes, state.favoriteSearches, state.favoriteCategories);
    // Update the local user configuration store
    getUserConfiguration_1.default().UserOptions.FavoriteNodes = favoriteNodesRaw;
    // Service request to update user options for FavoriteFolders
    return updateFavoritesUserOptionService_1.default(favoriteNodesRaw);
}));
//# sourceMappingURL=updateFavoritesUserOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-favorites-store/lib/actions/updateFavoritesUserOption.js
// module id = 2668
// module chunks = 14 68